import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=077d76b1&scoped=true&"
import script from "./KanbanView.vue?vue&type=script&lang=js&"
export * from "./KanbanView.vue?vue&type=script&lang=js&"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=077d76b1&prod&lang=css&"
import style1 from "./KanbanView.vue?vue&type=style&index=1&id=077d76b1&prod&lang=css&"
import style2 from "./KanbanView.vue?vue&type=style&index=2&id=077d76b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d76b1",
  null
  
)

export default component.exports